import { NavLink, Outlet, useLocation } from "react-router-dom";
import {
  LayoutDashboard, Radio, Route, Shield, ListChecks, Globe2,
  PhoneCall, AlertTriangle, FileCode2, Users, LogOut, ChevronsLeft, Activity, Menu, Megaphone, Hash, HeartPulse, Archive, ClipboardList, Phone, Network, Workflow, Building2, Router, Music, Headphones, UserCheck, Clock3, BadgeCheck, ChevronDown, Gauge, Settings, BarChart3, KeyRound, PhoneForwarded, Wrench, Calculator, Inbox, AudioLines, Stethoscope, Rocket
} from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "@/components/ui/sonner";
import oneSipSymbol from "@/assets/onesip-symbol-primary.png";
import oneSipLogo from "@/assets/onesip-logo-primary.png";

const NAV_GROUPS = [
  { id: "control", label: "Painel de controle", icon: Gauge, items: [{ to: "/", icon: LayoutDashboard, label: "Dashboard", end: true }, { to: "/assistente-configuracao", icon: Rocket, label: "Assistente de configuracao", roles: ["superadmin", "admin", "tenant_admin", "manager"] }, { to: "/teste-chamada", icon: PhoneCall, label: "Teste de chamada", roles: ["superadmin", "admin", "tenant_admin", "manager", "supervisor"] }, ] },
  { id: "clients", label: "Clientes", icon: Building2, superAdminOnly: true, items: [
    { to: "/clientes/cadastro", icon: Building2, label: "Cadastro de clientes" }, { to: "/clientes/licencas", icon: KeyRound, label: "Licenças" },
  ]},
  { id: "callcenter", label: "Call center", icon: Headphones, items: [
    { to: "/call-center/supervisao", icon: Gauge, label: "Painel de Supervisao", roles: ["superadmin", "admin", "tenant_admin", "manager", "supervisor"] },
    { to: "/painel-tv", icon: Activity, label: "Painel para TV", roles: ["superadmin", "admin", "tenant_admin", "manager", "supervisor", "viewer"] },
    { to: "/call-center/filas", icon: Users, label: "Filas de atendimento" }, { to: "/call-center/agentes", icon: Headphones, label: "Cadastro de agentes" }, { to: "/call-center/opcoes-pausa", icon: Clock3, label: "Opcoes de pausa", roles: ["superadmin", "admin", "tenant_admin", "manager", "supervisor"] },
    { to: "/call-center/mensagens-atendimento", icon: Megaphone, label: "Mensagens de atendimento" }, { to: "/call-center/mensagens-espera", icon: Music, label: "Mensagens de espera" },
    { to: "/call-center/relatorios/visao-geral", icon: BarChart3, label: "Relatorios" },
    { to: "/call-center/dimensionamento", icon: Calculator, label: "Dimensionamento" },
  ]},
  { id: "extensions", label: "Ramais", icon: Phone, items: [
    { to: "/ramais/cadastro", icon: Phone, label: "Cadastro de ramais" }, { to: "/ramais/permissoes", icon: Shield, label: "Permissões de ligações" }, { to: "/ramais/pins-ligacao", icon: KeyRound, label: "PIN de ligação externa" },
    { to: "/ramais/monitorar", icon: Activity, label: "Monitorar ramais" }, { to: "/ramais/manutencao", icon: Wrench, label: "Manutenção técnica", roles: ["superadmin", "admin", "tenant_admin", "manager", "supervisor"] }, { to: "/ramais/correio-voz", icon: Inbox, label: "Correio de voz", roles: ["superadmin", "admin", "tenant_admin"] }, { to: "/ramais/grupos", icon: Network, label: "Grupos de toque" }, { to: "/ramais/grupos-captura", icon: PhoneCall, label: "Grupos de captura" },
  ]},
  { id: "trunks", label: "Troncos", icon: Radio, items: [
    { to: "/troncos/cadastro", icon: Radio, label: "Cadastro de troncos" }, { to: "/troncos/dids", icon: Hash, label: "Cadastro de DID / DDR" },
    { to: "/troncos/condicoes-tempo", icon: Clock3, label: "Condições de tempo" },
    { to: "/troncos/ura", icon: Workflow, label: "URA / IVR" },
  ]},
  { id: "reports", label: "Relatorios", icon: BarChart3, items: [
    { to: "/relatorios/ligacoes", icon: ListChecks, label: "Relatorio de ligacoes" }, { to: "/relatorios/qualidade-operacional", icon: Activity, label: "Qualidade operacional" }, 
  ]},
  { id: "lcr", label: "Rotas / LCR", icon: Route, items: [
    { to: "/lcr/rotas-saida", icon: Route, label: "Rotas de saída" }, { to: "/lcr/regras-discagem", icon: PhoneForwarded, label: "Regras de discagem LCR" },
    { to: "/lcr/permissoes", icon: Shield, label: "Permissão de rotas" }, { to: "/lcr/condicoes-tempo", icon: Clock3, label: "Condições de tempo" },
  ]},
  { id: "system", label: "Configuração sistema", icon: Settings, items: [
    { to: "/sistema/saude", icon: HeartPulse, label: "Saúde do IPBX", superAdminOnly: true}, { to: "/sistema/diagnostico", icon: Stethoscope, label: "Diagnostico por cliente", roles: ["superadmin", "admin", "tenant_admin", "manager", "supervisor"] }, { to: "/sistema/musica-espera", icon: Music, label: "Música de espera" },
    { to: "/sistema/anuncios", icon: Megaphone, label: "Anúncios" }, { to: "/sistema/gerador-audios", icon: AudioLines, label: "Gerador de áudios" }, { to: "/sistema/freeswitch", icon: FileCode2, label: "Voxyra Agente" },
    { to: "/sistema/monitoramento-registros", icon: Activity, label: "Monitoramento de registros" }, { to: "/sistema/gravacoes", icon: Archive, label: "Gravações" }, { to: "/sistema/codigos-facilidade", icon: Hash, label: "Codigos de facilidade" }, { to: "/sistema/data-hora", icon: Clock3, label: "Data e hora", superAdminOnly: true }, { to: "/sistema/geoip", icon: Globe2, label: "GeoIP", superAdminOnly: true }, { to: "/sistema/protecao-sip", icon: Shield, label: "Protecao SIP", superAdminOnly: true }, { to: "/sistema/backups", icon: Archive, label: "Backup" },
  ]},
  { id: "admin", label: "Configuração administrativa", icon: Wrench, items: [
    { to: "/administrativo/antifraude", icon: AlertTriangle, label: "Anti-fraude" }, { to: "/administrativo/certificados", icon: BadgeCheck, label: "Certificados", superAdminOnly: true },
    { to: "/administrativo/microsoft-teams", icon: Workflow, label: "Microsoft Teams", superAdminOnly: true },
  ]},
  { id: "provision", label: "Provisionamento", icon: Router, items: [
    { to: "/provisionamento/cisco", icon: Router, label: "Aparelhos Cisco" }, { to: "/provisionamento/yealink", icon: Phone, label: "Aparelhos Yealink" },
  ]},
  { id: "audit", label: "Auditoria", icon: ClipboardList, items: [{ to: "/auditoria", icon: ClipboardList, label: "Logs de auditoria" }] },
  { id: "other", label: "Outros", icon: Menu, items: [
    { to: "/acl", icon: Shield, label: "ACL - IP e DNS" }, { to: "/usuarios", icon: Users, label: "Usuários" }, { to: "/console-agente", icon: UserCheck, label: "Console do agente" },
  ]},
];

const NAV_GROUP_TONES = {
  control: "blue",
  clients: "cyan",
  callcenter: "violet",
  extensions: "green",
  trunks: "orange",
  reports: "rose",
  lcr: "amber",
  system: "slate",
  admin: "red",
  provision: "indigo",
  audit: "teal",
  other: "blue",
};

export default function Layout() {
  const { user, logout, tenants, activeTenantId, setActiveTenantId, reloadTenants } = useAuth();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [uptime, setUptime] = useState("--");
  const [health, setHealth] = useState({ active: 0 });
  const [openGroups, setOpenGroups] = useState({ control: true, clients: true });
  const [pendingConfig, setPendingConfig] = useState(null);
  const [applyingConfig, setApplyingConfig] = useState(false);
  const [applyError, setApplyError] = useState("");
  const optimisticPendingState = () => ({
    id: "voxyra_ipbx",
    pending: true,
    module: "ipbx",
    reason: "Alteracao operacional",
    changed_at: new Date().toISOString(),
    changed_by: user?.email || null,
    last_error: null,
  });

  useEffect(() => {
    const start = Date.now();
    const tick = () => {
      const s = Math.floor((Date.now() - start) / 1000);
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      setUptime(`${d}d ${h.toString().padStart(2, "0")}h ${m.toString().padStart(2, "0")}m`);
    };
    tick();
    const iv = setInterval(tick, 30000);

    const load = async () => {
      try {
        const { data } = await api.get("/metrics/dashboard");
        setHealth({ active: data.active_channels });
      } catch (_err) { /* ignore */ }
    };
    const loadPending = async () => {
      try {
        const { data } = await api.get("/ipbx-config/pending", { params: { _ts: Date.now() } });
        setPendingConfig(data);
        if (!data?.last_error) setApplyError("");
      } catch (_err) { /* ignore */ }
    };
    const onPending = () => {
      setPendingConfig((current) => ({
        ...(current || optimisticPendingState()),
        pending: true,
        reason: current?.reason || "Alteracao operacional",
        changed_at: new Date().toISOString(),
        changed_by: user?.email || current?.changed_by || null,
      }));
      loadPending();
    };
    window.addEventListener("voxyra-ipbx-config-pending", onPending);
    load();
    loadPending();
    const iv2 = setInterval(load, 4000);
    const iv3 = setInterval(loadPending, 6000);
    return () => {
      clearInterval(iv);
      clearInterval(iv2);
      clearInterval(iv3);
      window.removeEventListener("voxyra-ipbx-config-pending", onPending);
    };
  }, []);

  const isSuperAdmin = String(user?.role || "").toLowerCase() === "superadmin";
  const isSupervisor = String(user?.role || "").toLowerCase() === "supervisor";
  const activeTenantLabel = tenants.find((tenant) => String(tenant.id) === String(activeTenantId))?.nome || "";

  const applyConfig = async () => {
    setApplyingConfig(true);
    setApplyError("");
    try {
      await api.post("/ipbx-config/apply");
      const { data } = await api.get("/ipbx-config/pending", { params: { _ts: Date.now() } });
      setPendingConfig(data);
      toast.success("Configuracoes aplicadas com sucesso.");
    } catch (err) {
      const detail = err?.response?.data?.detail || "Nao foi possivel aplicar as configuracoes.";
      setApplyError(detail);
      toast.error("Falha ao aplicar configuracoes.", { description: String(detail) });
    } finally {
      setApplyingConfig(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="app-layout">
      {/* Sidebar */}
      <aside
        className={`transition-all duration-200 border-r border-[color:var(--border-default)] bg-[color:var(--bg-surface)] flex flex-col ${collapsed ? "w-14" : "w-72"}`}
        data-testid="sidebar"
      >
        <div className={`relative h-14 flex items-center border-b border-[color:var(--border-default)] ${collapsed ? "justify-center px-2" : "px-3"}`}>
          {collapsed ? (
            <div className="w-8 h-8 flex items-center justify-center shrink-0">
              <img src={oneSipSymbol} alt="OneSIP" className="w-8 h-8 object-contain" />
            </div>
          ) : (
            <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
              <img src={oneSipLogo} alt="OneSIP" className="w-36 h-10 object-contain" />
            </div>
          )}
          <button
            data-testid="sidebar-toggle"
            className="absolute right-3 z-10 p-1 text-[color:var(--text-muted)] hover:text-[color:var(--text-primary)]"
            onClick={() => setCollapsed(!collapsed)}
            title={collapsed ? "Expandir menu" : "Recolher menu"}
            aria-label={collapsed ? "Expandir menu" : "Recolher menu"}
          >
            {collapsed ? <Menu size={14} /> : <ChevronsLeft size={14} />}
          </button>
        </div>

        {collapsed && (
          <div className="px-2 py-2 border-b border-[color:var(--border-default)]">
            <button
              type="button"
              className="w-full h-9 rounded-md border border-[color:var(--border-default)] bg-[color:var(--bg-elevated)] text-[color:var(--text-primary)] flex items-center justify-center hover:bg-[color:var(--bg-surface-2)]"
              onClick={() => setCollapsed(false)}
              title="Expandir menu"
              aria-label="Expandir menu"
            >
              <Menu size={16} />
            </button>
          </div>
        )}

        <nav className="flex-1 py-3 px-2 space-y-1 overflow-y-auto">
          {NAV_GROUPS.filter((group) => (!group.adminOnly || ["admin", "tenant_admin", "superadmin"].includes(user?.role)) && (!group.superAdminOnly || user?.role === "superadmin")).map((group) => {
            const items = group.items.filter((item) => {
              const supervisorItem = item.to === "/call-center/supervisao"
                || item.to === "/painel-tv"
                || item.to.startsWith("/call-center/relatorios");
              return (!item.superAdminOnly || user?.role === "superadmin")
                && (!item.roles || item.roles.includes(user?.role))
                && (!isSupervisor || supervisorItem);
            });
            if (!items.length) return null;
            const tone = NAV_GROUP_TONES[group.id] || "blue";
            if (collapsed) return items.map((item) => <NavLink key={item.to} to={item.to} end={item.end} className={({isActive}) => `side-link side-link-collapsed ${isActive ? "active" : ""}`} title={item.label}><span className={`nav-icon nav-icon-${tone}`}><item.icon size={16}/></span></NavLink>);
            const open = !!openGroups[group.id];
            return <div key={group.id}>
              <button className="nav-group-toggle" onClick={() => setOpenGroups((old) => ({...old, [group.id]: !open}))}>
                <span className={`nav-icon nav-icon-${tone} nav-group-icon`}><group.icon size={14}/></span><span className="flex-1 min-w-0 text-left whitespace-normal leading-tight">{group.label}</span><ChevronDown size={12} className={`shrink-0 transition-transform ${open ? "rotate-180" : ""}`}/>
              </button>
              {open && <div className="ml-2 pl-2 border-l border-[color:var(--border-default)] space-y-0.5">{items.map((item) => <NavLink key={item.to} to={item.to} end={item.end} className={({isActive}) => `side-link !h-auto min-h-9 py-1.5 ${isActive ? "active" : ""}`}><span className={`nav-icon nav-icon-${tone}`}><item.icon size={15}/></span><span className="min-w-0 whitespace-normal leading-tight">{item.label}</span></NavLink>)}</div>}
            </div>;
          })}
        </nav>

        {!collapsed && (
          <div className="p-3 border-t border-[color:var(--border-default)]">
            <div className="text-[10px] uppercase tracking-widest text-[color:var(--text-muted)] mb-1">Uptime</div>
            <div className="font-mono text-xs text-[color:var(--accent-green)]" data-testid="sidebar-uptime">{uptime}</div>
          </div>
        )}
      </aside>

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Topbar */}
        <header className="h-14 border-b border-[color:var(--border-default)] bg-[color:var(--bg-surface)] flex items-center px-4 gap-4">
          <div className="flex items-center gap-2">
            <span className="led led-green" />
            <span className="text-xs font-mono uppercase tracking-widest text-[color:var(--text-secondary)]" data-testid="server-status">
              Server ONLINE
            </span>
          </div>
          <div className="text-[color:var(--border-default)]">|</div>
          <div className="flex items-center gap-2">
            <Activity size={14} className="text-[color:var(--accent-amber)]" />
            <span className="text-xs font-mono text-[color:var(--text-secondary)]" data-testid="topbar-active-channels">
              {health.active} ligações ativas
            </span>
          </div>
          <div className="flex-1" />
          {isSuperAdmin && (
            <div className="flex items-center gap-2">
              <div className="text-right leading-tight">
                <div className="text-[10px] uppercase tracking-widest text-[color:var(--text-muted)]">Cliente em manutencao</div>
                <div className="text-[11px] text-[color:var(--text-secondary)] truncate max-w-[180px]">
                  {activeTenantLabel || "Selecione um cliente"}
                </div>
              </div>
              <select
                className="sbc-input min-w-[220px] h-10"
                value={activeTenantId || ""}
                onChange={(event) => setActiveTenantId(event.target.value)}
                data-testid="topbar-tenant-selector"
              >
                {tenants.map((tenant) => (
                  <option key={tenant.id} value={tenant.id}>
                    {tenant.nome || tenant.name || tenant.id}
                  </option>
                ))}
              </select>
              <button
                type="button"
                className="sbc-btn"
                title="Recarregar clientes"
                onClick={reloadTenants}
                data-testid="topbar-tenant-reload"
              >
                <Building2 size={14} />
              </button>
            </div>
          )}
          <div className="flex items-center gap-3">
            <div className="text-right">
              <div className="text-xs font-medium" data-testid="user-name">{user?.name}</div>
              <div className="text-[10px] uppercase tracking-widest text-[color:var(--text-muted)]" data-testid="user-role">
                {user?.role}
              </div>
            </div>
            <div className="w-8 h-8 rounded-full bg-[color:var(--bg-elevated)] border border-[color:var(--border-default)] flex items-center justify-center text-xs font-mono">
              {(user?.name || "?").charAt(0).toUpperCase()}
            </div>
            <button
              data-testid="logout-btn"
              className="sbc-btn"
              onClick={logout}
              title="Sair"
            >
              <LogOut size={14} />
            </button>
          </div>
        </header>

        {pendingConfig?.pending && (
          <div className="border-b border-[rgba(245,158,11,0.35)] bg-[rgba(245,158,11,0.10)] px-4 py-3 flex items-center justify-between gap-3" data-testid="pending-config-banner">
            <div className="min-w-0">
              <div className="text-xs font-semibold text-[color:var(--accent-amber)]">Configuracoes pendentes no Voxyra IPBX</div>
              <div className="text-[11px] text-[color:var(--text-secondary)] font-mono truncate">
                {pendingConfig.reason || "Alteracao operacional"} · {pendingConfig.changed_at ? new Date(pendingConfig.changed_at).toLocaleString("pt-BR") : "agora"}
              </div>
              {(applyError || pendingConfig.last_error) && <div className="text-[11px] text-red-500 mt-1">{applyError || pendingConfig.last_error}</div>}
            </div>
            <button className="sbc-btn sbc-btn-primary shrink-0" onClick={applyConfig} disabled={applyingConfig} data-testid="apply-config-btn">
              {applyingConfig ? "Aplicando..." : "Aplicar configuracoes"}
            </button>
          </div>
        )}

        {/* Content */}
        <main className="flex-1 overflow-auto p-6" data-testid="main-content">
          <div key={location.pathname} className="route-transition">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
